import { render } from "./TrainingGroupComponent.vue?vue&type=template&id=ae48717c&scoped=true"
import script from "./TrainingGroupComponent.vue?vue&type=script&lang=js"
export * from "./TrainingGroupComponent.vue?vue&type=script&lang=js"

import "./TrainingGroupComponent.vue?vue&type=style&index=0&id=ae48717c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae48717c"]])

export default __exports__